'use client';

import React, {FC, useState, useEffect} from "react";

export const LoyaltyFrame: FC = () => {
    const [iframeHeight, setIframeHeight] = useState<number>(300);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // Здесь вы можете также проверить event.origin, чтобы принимать сообщения только от доверенного домена
            if (event.data && event.data.height) {
                setIframeHeight(event.data.height);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return (
        <iframe
            id="offerFrame"
            className="w-full border-none rounded-[24px] overflow-hidden bg-white"
            src={`https://newftch.ru/api/game`}
            style={{
                width: '100%',
                height: `${iframeHeight}px`,
                border: 'none',
                maxWidth: '400px',
                overflow: 'hidden' }
            }
            scrolling={'no'}
            allowFullScreen
            title="Предложения от партнёров"
        />
    )
}
